<div
  class="dup-badge"
  [class.dup-badge--big]="size === 'big'"
  cdkOverlayOrigin
  #badgeOrigin="cdkOverlayOrigin"
  (click)="togglePin($event)"
  (mouseenter)="onPointerEnter()"
  (mouseleave)="onPointerLeave()"
>
  <ui-icon name="TriangleAlert" size="medium" class="dup-badge-icon"></ui-icon>
  {{ 'quotations_and_orders.duplicate_badge' | translate }}
</div>

<!--
  The panel lives in a body-level CDK overlay rather than inside the row: as a
  descendant it was clipped by .table-wrapper's overflow and trapped in the
  table's stacking context (rendering behind the pagination). The overlay also
  brings viewport-aware placement — see `panelPositions` for the fallbacks.
-->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="badgeOrigin"
  [cdkConnectedOverlayOpen]="isPanelOpen"
  [cdkConnectedOverlayPositions]="panelPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayPush]="true"
  (overlayOutsideClick)="onOutsideClick($event)"
  (positionChange)="onPositionChange($event)"
>
  <div
    class="dup-panel"
    [class.dup-panel--above]="panelAbove"
    [class.dup-panel--align-end]="panelAlignEnd"
    (click)="$event.stopPropagation()"
    (mouseenter)="onPointerEnter()"
    (mouseleave)="onPointerLeave()"
  >
    <div class="dup-panel-arrow"></div>
    <div class="dup-panel-header">
      <ui-icon name="TriangleAlert" size="medium" class="dup-panel-warn-icon"></ui-icon>
      <span>{{ 'quotations_and_orders.duplicate_already_received' | translate: { count: duplicateInfo?.orders?.length } }}</span>
    </div>
    <div class="dup-panel-list">
      <div class="dup-panel-row"
           *ngFor="let dup of duplicateInfo?.orders"
           (click)="navigateTo(dup.id, $event)">
        <div class="dup-row-left">
          <div class="dup-row-company">{{ dup.partner_name || dup.name }}</div>
          <div class="dup-row-ids">
            <span>{{ dup.name }}</span>
          </div>
        </div>
        <div class="dup-row-right">
          <div class="dup-row-date">{{ dup.date_order | date:'dd/MM/yyyy' }}</div>
          <div class="dup-row-bottom">
            <span class="dup-status-pill" [ngStyle]="getStatusStyles(dup.status)">
              {{ getStatusTranslation(dup.status) }}
            </span>
            <img src="assets/icones/open-link.svg" class="dup-open-icon" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="dup-panel-footer">
      <span class="dup-panel-hint">{{ 'quotations_and_orders.duplicate_panel_footer' | translate }}</span>
      <button
        type="button"
        class="dup-dismiss-btn"
        *appHasPermission="{ module: 'order', action: 'edit' }"
        (click)="dismiss($event)">
        {{ 'quotations_and_orders.duplicate_dismiss_action' | translate }}
      </button>
    </div>
  </div>
</ng-template>
